import { Component, OnInit, Inject, Renderer2, ElementRef, ViewChild, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CoursesService } from 'src/providers/courses.service';
import { LOCAL_STORAGE, WINDOW } from '@ng-toolkit/universal';
import { Router } from '@angular/router';
import { CartService } from 'src/providers/cart.service';
import { LoginService } from 'src/providers/login.service';
import { LoginModal } from '../header/header.component';
import { DashboardService } from 'src/providers/dashboard.service';


@Component({
  selector: 'course-coupon-dialog',
  templateUrl: './coupon.html',
  styleUrls: ['./home-new.component.scss']
})

export class CourseCouponDialog {
  cartArray: any;
  couponCode: any;
  couponList: any[] = [];
  token: any;
  referralCode: any;
  constructor(public dialogRef: MatDialogRef<CourseCouponDialog>, public cartService: CartService,
    @Inject(LOCAL_STORAGE) public sessionStorage: any, public matSnackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.token = this.sessionStorage.getItem('usertoken');
    this.getCoupons()
  }

  getCoupons() {
    this.couponList = []

    this.cartService.getCustomCourseCoupons(this.data.course).subscribe(res => {
      if (res.success) {
        //  && item.show_coupon
        res.data.forEach((item: any) => {
          if (item.status && !item.show_coupon) {
            this.couponList.push(item)
          }
        })
        // this.couponList = res.data
      }
    })

  }

  applyCoupon(obj: any) {
    this.couponCode = obj.coupon_code;
    this.apply()
  }

  couponMessage: any;
  couponApplied: boolean = false;
  apply() {
    if (this.couponCode) {
      let reqData = {
        code: this.couponCode,
        id: this.data.course
      }

      this.cartService.applyCustomCourseCoupon(reqData, this.token).subscribe(res => {
        if (res.success) {
          if (this.data.totalPrice > parseInt(res.data[0].discount_amount)) {
            this.sessionStorage.setItem('couponCode', this.couponCode)
            this.dialogRef.close(res)
          } else {
            this.matSnackBar.open('Cart Value is not enough to Apply Coupon', 'OK', {
              verticalPosition: 'top',
              duration: 2000,
              panelClass: 'snack-error'
            })
            this.couponMessage = 'Cart Value is not enough to Apply Coupon'
            this.couponApplied = false;
            this.cartArray.discount_amount = '';
            this.sessionStorage.removeItem('couponCode')
            this.sessionStorage.setItem('cartArray', JSON.stringify(this.cartArray))
            this.couponCode = '';
          }

        } else {
          this.matSnackBar.open(res.data, 'OK', {
            verticalPosition: 'top',
            duration: 2000,
            panelClass: 'snack-error'
          })
          this.couponMessage = res.data
          this.couponApplied = false;
          this.cartArray.discount_amount = '';
          this.sessionStorage.removeItem('couponCode')
          this.sessionStorage.setItem('cartArray', JSON.stringify(this.cartArray))
        }
      })


    } else if (this.referralCode) {
      let reqData = {
        code: this.referralCode,
        id: this.data.course
      }
      this.cartService.applyCustomCourseReferral(this.token, reqData).subscribe(res => {
        if (res.success && res.data != 'referral_code does not exist') {
          this.sessionStorage.setItem('referralCode', this.referralCode)
          this.dialogRef.close(res)
        } else {
          this.matSnackBar.open(res.data, 'OK', {
            verticalPosition: 'top',
            duration: 2000,
            panelClass: 'snack-error'
          })
          this.couponMessage = res.data
          this.couponApplied = false;
          this.cartArray.referral_amount = '';
          this.sessionStorage.removeItem('referralCode')
          this.sessionStorage.setItem('cartArray', JSON.stringify(this.cartArray))
        }
      })
    } else {
      this.matSnackBar.open('Enter Coupon/Referral Code', 'OK', {
        verticalPosition: 'top',
        duration: 2000,
        panelClass: 'snack-error'
      })
    }


  }

}

@Component({
  selector: 'footer-view',
  templateUrl: './footer-view.html',
  styleUrls: ['./home-new.component.scss']
})

export class FooterViewDialog {

  token: any;
  discountAmount: any = 0;
  couponCode: any;
  userData: any;
  productId: any;
  totalActualPrice: any = 0;
  constructor(public dialogRef: MatDialogRef<FooterViewDialog>, @Inject(MAT_DIALOG_DATA) public productDetails: any,
    @Inject(LOCAL_STORAGE) public sessionStorage: any, public cartService: CartService,
    public router: Router, public matSnackBar: MatSnackBar, public dialog: MatDialog,
    public dashboardService: DashboardService,
    public loginService: LoginService, public coursesService: CoursesService) {
    if (this.sessionStorage.getItem('usertoken')) {
      this.token = this.sessionStorage.getItem('usertoken');
      this.getProfile('')

    }
    this.cartArray = this.productDetails.cartArray;
    this.totalActualPrice = 0;
    this.totalOfferPrice = 0;
    this.cartArray.forEach(course => {
      this.totalActualPrice = this.totalActualPrice + course.actual_price;
      this.totalOfferPrice = this.totalOfferPrice + course.offer_price;
    })
  }


  closeDialog() {
    this.dialogRef.close()
  }

  getProfile(val: any) {
    this.dashboardService.getProfile(this.token).subscribe(res => {
      if (res.success) {
        this.userData = res.data[0];
        this.sessionStorage.setItem('userData', JSON.stringify(this.userData));
        this.sessionStorage.setItem('mockData', JSON.stringify(res.mock_login))
        this.loginService.userProfile(this.userData)
        if (val == 'checkout') {
          this.buynow()
        }
      }
    })
  }

  referralAmount: any = 0;
  referralCode: any;

  //coupon Modal
  couponOpen() {
    if (this.token && this.totalOfferPrice > 0) {
      const dialog = this.dialog.open(CourseCouponDialog, {
        width: '470px',
        panelClass: 'coupon-modal',
        data: { course: this.productDetails.course.id, totalPrice: this.totalOfferPrice }
      })

      dialog.afterClosed().subscribe(res => {
        if (res) {
          if (res.data == 'Invalid Code or Not available for this course') {
            this.sessionStorage.removeItem('couponCode')
          } else if (res.data == 'referral_code does not exist') {
            this.sessionStorage.removeItem('referralCode')
          } else {
            if (res.data[0].amount) {
              this.referralAmount = res.data[0].amount;
              this.referralCode = this.sessionStorage.getItem('referralCode')
              this.totalOfferPrice = 0;
              this.cartArray.forEach(course => {
                this.totalOfferPrice = this.totalOfferPrice + course.offer_price;
              })
              setTimeout(() => {
                this.totalOfferPrice = this.totalOfferPrice - parseInt(this.referralAmount)
              }, 500)

            } else {
              this.discountAmount = res.data[0].discount_amount;
              this.couponCode = this.sessionStorage.getItem('couponCode');
              this.totalOfferPrice = 0;
              this.cartArray.forEach(course => {
                this.totalOfferPrice = this.totalOfferPrice + course.offer_price;
              })
              setTimeout(() => {
                this.totalOfferPrice = this.totalOfferPrice - parseInt(this.discountAmount)
              }, 500)
            }

          }
        }
      })
    } else if (!this.token) {
      this.login()
      // this.matSnackBar.open('Please Login to continue', 'OK', {
      //   verticalPosition: 'top',
      //   duration: 3000,
      //   panelClass: 'snack-error'
      // })
    } else if (this.totalOfferPrice == 0) {
      this.matSnackBar.open('Cart Value shouldnt be 0', 'OK', {
        verticalPosition: 'top',
        duration: 3000,
        panelClass: 'snack-error'
      })
    }

  }

  // getProfile() {
  //   this.dashboardService.getProfile(this.token).subscribe(res => {
  //     if (res.success) {
  //       this.userData = res.data[0];
  //       this.sessionStorage.setItem('userData', JSON.stringify(this.userData));
  //       this.sessionStorage.setItem('mockData', JSON.stringify(res.mock_login))
  //       this.loginService.userProfile(this.userData)
  //     }
  //   })
  // }

  login(){
    const dialogRef = this.dialog.open(LoginModal, {
      width: '750px',
      panelClass: 'login_modal',
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {

      } else if (typeof (result) == 'object') {
        if (this.sessionStorage.getItem('usertoken')) {
          this.token = this.sessionStorage.getItem('usertoken');
          this.getProfile('')
        } else {
          this.userData = result;
          this.token = this.sessionStorage.getItem('usertoken');;
          this.sessionStorage.setItem('userData', JSON.stringify(result));
          this.loginService.userProfile(this.userData)
         
        }
      }
    });
  }


  totalOfferPrice: number = 0;
  cartArray: any[] = []
  removeCoupon() {
    this.discountAmount = 0;
    this.couponCode = '';
    this.sessionStorage.removeItem('couponCode')
    this.referralAmount = 0;
    this.referralCode = '';
    this.sessionStorage.removeItem('referralCode')
    this.totalOfferPrice = 0;
    this.cartArray.forEach(course => {
      this.totalOfferPrice = this.totalOfferPrice + course.offer_price;
    })
  }

  checkLogin() {

  }

  submittedBuynow: boolean = false;


  buynow() {
    if (!this.submittedBuynow) {
      if (this.token && this.userData.email && this.userData.phone_no && this.userData.first_name) {
        this.submittedBuynow = true;
        let courseLt: any[] = [];
        this.cartArray.forEach(cart => {
          courseLt.push(cart.id)
        })
        let reqObj: any;
        if (this.couponCode) {
          reqObj = {
            email: this.userData.email,
            phone: this.userData.phone_no,
            custom_course_id: this.productDetails.course.id,
            coupon_code: this.couponCode,
            custom_course_lt: courseLt,
            discountAmount: this.discountAmount
          }
        } else if (this.referralCode) {
          reqObj = {
            email: this.userData.email,
            phone: this.userData.phone_no,
            custom_course_id: this.productDetails.course.id,
            referral_code: this.referralCode,
            custom_course_lt: courseLt,
            referralAmount: this.referralAmount
          }
        } else {
          reqObj = {
            email: this.userData.email,
            phone: this.userData.phone_no,
            custom_course_id: this.productDetails.course.id,
            custom_course_lt: courseLt
          }
        }
        this.dialogRef.close(reqObj)
      }else if(!this.token){
        this.login()
      }
       else if (!this.userData.email || !this.userData.phone_no || this.userData.first_name) {
        this.matSnackBar.open('Please update your Profile to continue', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
      else {
        this.login()
        // this.matSnackBar.open('Please Login to continue', 'OK', {
        //   verticalPosition: 'top',
        //   duration: 3000,
        //   panelClass: 'snack-error'
        // })
      }
    }

  }

}